var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.priceParams
    ? _c(
        "div",
        { staticClass: "event-card__footer" },
        [
          _vm.isShowDiff
            ? [
                _c("p", {
                  staticClass: "event-card__price-old",
                  domProps: { innerHTML: _vm._s(_vm.price.PRINT_VALUE) }
                }),
                _vm._v(" "),
                _c("p", {
                  staticClass: "event-card__price",
                  domProps: {
                    innerHTML: _vm._s(_vm.price.PRINT_DISCOUNT_VALUE)
                  }
                }),
                _vm._v(" "),
                _c("p", {
                  staticClass: "event-card__price",
                  domProps: {
                    innerHTML: _vm._s(_vm.price.DISCOUNT_DIFF_PERCENT)
                  }
                }),
                _vm._v(" "),
                _c("p", {
                  staticClass: "event-card__price",
                  domProps: { innerHTML: _vm._s(_vm.price.PRINT_DISCOUNT_DIFF) }
                })
              ]
            : [
                _c("div", { staticClass: "event-card__prices" }, [
                  _c("span", {
                    staticClass: "event-card__price",
                    domProps: { innerHTML: _vm._s(_vm.prices.current) }
                  }),
                  _vm._v(" "),
                  _vm.prices.old
                    ? _c("span", {
                        staticClass: "event-card__price-old",
                        domProps: { innerHTML: _vm._s(_vm.prices.old) }
                      })
                    : _vm._e()
                ])
              ],
          _vm._v(" "),
          _vm._t("default")
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }